import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  return (
    <div className="page">
      <section className="hero" style={{minHeight: '50vh', paddingTop: 'calc(80px + var(--spacing-xl))'}}>
        <div className="container hero-content">
          <span className="section-label">Legal</span>
          <h1>Terms of Service</h1>
          <p>Last updated: December 29, 2025</p>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="card" style={{ padding: 'var(--spacing-xl)' }}>
            <p>Welcome to SEVENHC. By using our services, you agree to these terms.</p>

            <h2>1. Services</h2>
            <p>SEVENHC provides custom software development, web development, and IT consulting services as described on our website.</p>

            <h2>2. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of your account</li>
              <li>Use our services in compliance with applicable laws</li>
            </ul>

            <h2>3. Intellectual Property</h2>
            <p>All content and materials available through our services are protected by intellectual property rights owned by SEVENHC or our licensors.</p>

            <h2>4. Limitation of Liability</h2>
            <p>SEVENHC shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.</p>

            <h2>5. Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of modified terms.</p>

            <h2>6. Contact</h2>
            <p>For questions about these Terms, contact us at <a href="mailto:legal@sevenhc.net">legal@sevenhc.net</a></p>

            <div style={{ marginTop: 'var(--spacing-lg)', paddingTop: 'var(--spacing-lg)', borderTop: '1px solid var(--color-black-lighter)' }}>
              <Link to="/contact" className="btn btn-primary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
